import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';
import { displayErrorMessage, sortWithLocale } from 'utils/tools_functions';
import Table from 'components/generics/Table/Table';
import ExploitationTableRow from 'components/pages/Cooperative/table/ExploitationTableRow';
import useAUTH from 'providers/Auth/useAuth';
import {
  importWiuzExploitation,
  getExploitationTypes,
  getSecteurLight,
  importParcelsWiuz,
} from 'services/API/Cooperative';
import Button from 'components/generics/Button';
import { toast } from 'react-toastify';
import { useCheckStatus } from 'providers/ImportStatus';
import { IMPORT_FROM, IMPORT_TYPE } from 'utils/GlobalVariables';

function CooperativeExploitation() {
  const { user } = useAUTH();
  const cooperativeId = localStorage.getItem('cooperative');
  const { t } = useTranslation();

  const [data, setData] = useState([]);
  const [sectors, setSectors] = useState([]);
  const [types, setTypes] = useState([]);
  const [checked, setChecked] = useState([]);
  const [dataToHandle, setDataToHandle] = useState([]);
  const navigate = useNavigate();
  const [idGet, setIdGet] = useState('');
  const location = useLocation();
  const from = location?.state?.from;
  const nextCampaignChosen = location?.state?.nextCampaignChosen;
  const procedureExploitation = location?.state?.procedureExploitation;
  const checkStatus = useCheckStatus();

  useEffect(() => {
    setIdGet(cooperativeId ? cooperativeId : user.cooperative.id);
    getExploitationTypes().then((resp) => setTypes(resp.data.data));
  }, [user.cooperative.id, cooperativeId]);

  useEffect(() => {
    if (idGet) {
      getSecteurLight(idGet).then((resp) => {
        setSectors(resp.data.data);
      });
    }
  }, [idGet]);

  useEffect(() => {
    if (idGet && sectors.length > 0) {
      importWiuzExploitation(idGet).then((resp) => {
        const data = sortWithLocale(resp.data.data, 'wiuzExploitationName')?.map((exploit) => {
          return {
            exploitation: exploit,
            secteur: sectors,
            type: types,
          };
        });
        setData(data);
        setChecked(
          data.map((exploitationData) => ({
            exploitationId: exploitationData.exploitation.wiuzExploitationId,
            checked: false,
          })),
        );
      });
    }
  }, [sectors, idGet, types]);

  const handleData = (data) => {
    setDataToHandle([data]);
  };

  const deleteData = (exploitationId) => {
    setDataToHandle((prevData) => prevData.filter((d) => d?.exploitationId !== exploitationId));
  };

  const cancelImport = () => {
    navigate(`/exploitation/campaign`, { state: { nextCampaignChosen } });
  };

  const sendData = async () => {
    let canSendData = true;
    if (dataToHandle.length === 0) {
      toast.error(displayErrorMessage('ERR_NO_DATA_SELECTED'));
      canSendData = false;
    } else {
      dataToHandle.forEach((d) => {
        if (
          d?.sectorId === '' ||
          d?.sectorId === 0 ||
          d?.exploitationTypeId === '' ||
          d?.exploitationTypeId === 0
        ) {
          toast.error(displayErrorMessage('ERR_MISSING_DATA'));
          canSendData = false;
        }
      });
    }
    if (canSendData) {
      let formatedData = [];
      if (from === IMPORT_FROM.procedure) {
        formatedData = dataToHandle.map((exploitation) => ({
          ...exploitation,
          expectedForecastCampaign: nextCampaignChosen.stringFormat,
          procedureExploitation: Number(procedureExploitation),
        }));
      } else {
        formatedData = dataToHandle;
      }
      try {
        toast.success(t('success.importStarted'));
        const response = await importParcelsWiuz(idGet, { exploitations: formatedData });
        const jobId = response?.data?.data?.jobId;
        checkStatus(jobId);
      } catch (error) {
        console.log(error);
        toast.error(displayErrorMessage('ERR_IMPORT'));
      }
    }
  };

  return (
    <div className="section">
      <div className="main_container">
        <h1 className="title_section">{t('title.wiuzExploitationsList')}</h1>
        <Table
          header={[
            '',
            t('navigation.exploitations'),
            t('label.assoliaSectors'),
            t('label.exploitationTypes'),
          ]}
          data={data}
          RowElement={ExploitationTableRow}
          handleData={handleData}
          deleteData={deleteData}
          checked={checked}
          setChecked={setChecked}
          from={IMPORT_TYPE.wiuz}
        />
      </div>
      <div style={{ display: 'flex', justifyContent: 'flex-end' }}>
        <div className="add_button_container">
          <Button text={t('common.validate')} onClick={() => sendData()} />
        </div>
        {from === IMPORT_FROM.procedure && (
          <div className="add_button_container">
            <Button text={t('common.cancel')} onClick={() => cancelImport()} />
          </div>
        )}
      </div>
    </div>
  );
}

export default CooperativeExploitation;
